import styled from 'styled-components';

export const Container = styled.div`
    min-width: 320px;
`;

export const HeaderLogo = styled.img`
    height: 250px;
    width: 100%;
    background: black;
`;

const footerHeight = 60;
export const Footer = styled.div`
    background: black;
    height: ${footerHeight}px;
    width: 100%;
`;

export const FooterContent = styled.div`
    height: 100%;
    width: fit-content;
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-column-gap: 20px;
    margin: auto;
`;

export const FooterLink = styled.span`
    a {
        color: #666;
        font-family: 'ubuntu';
        font-size: 0.8em;
        text-decoration: none;
        line-height: ${footerHeight}px;

        &:hover {
            text-decoration: underline;
        }
    }
`;
